module.exports = __webpack_public_path__ + "img/iso14001-cn.92ff541b.png";